import {MajorOutageLeadDashboard as MajorOutageLeadDashboardFeature} from '@features/major-outage-lead-dashboard'
import {PermissionType} from '@hconnect/apiclient'
import {RcfaLinks} from '@hconnect/common/components/runningTimes'
import {AnalysisListType, SHIFT_QUICK_SELECT_SLOTS} from '@hconnect/common/types'
import {getMaintainAnalysisListUrl} from '@hconnect/common/utils'
import {PageTitle} from '@hconnect/uikit'
import {Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router'

import {useTranslationPrefix} from '../../shared/hooks'
import {PlantSelectBreadcrumb} from '../components'
import {
  generateCockpitShiftSummaryLink,
  getMajorOutageLeadPlantDowntimePagePath,
  getMajorOutageLeadStoppageAnalysisPath
} from '../utils'

type TitleProps = {
  title: React.ReactNode
  breadcrumbs?: React.ReactNode
}

const Title = ({title, breadcrumbs}: TitleProps) => {
  return (
    <Stack>
      {breadcrumbs}
      <PageTitle ml={0}>{title}</PageTitle>
    </Stack>
  )
}

type PathParameter = {
  plantId?: string
}

type Props = {
  permission: PermissionType
}

const EVENTS_SUMMARY_QUICK_SELECT_SLOT = SHIFT_QUICK_SELECT_SLOTS.PastShift

export const MajorOutageLeadDashboard = ({permission}: Props) => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')
  const navigate = useNavigate()
  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  const redirectToStoppageAnalysis = (equipmentId: string) => {
    void navigate(getMajorOutageLeadStoppageAnalysisPath(plantId, equipmentId))
  }

  const maintainAnalysisLinkPath = getMaintainAnalysisListUrl(plantId, AnalysisListType.MyPlant)
  const shiftSummaryLink = generateCockpitShiftSummaryLink(
    EVENTS_SUMMARY_QUICK_SELECT_SLOT,
    plantId
  )
  const handleShiftEventClick = () => {
    window.location.assign(shiftSummaryLink)
  }

  return (
    <MajorOutageLeadDashboardFeature
      plantId={plantId}
      titleSlot={
        <Title
          title={t(`${hrocPrefix}.majorOutageLeadDashboard.pageTitle`)}
          breadcrumbs={<PlantSelectBreadcrumb permission={permission} sx={{ml: 0}} />}
        />
      }
      onEquipmentClick={redirectToStoppageAnalysis}
      renderRunningTimeTooltipFooter={({rootCauseFailureAnalyses}) =>
        rootCauseFailureAnalyses && (
          <RcfaLinks plantId={plantId} rootCauseFailureAnalyses={rootCauseFailureAnalyses} />
        )
      }
      shiftSummaryHref={shiftSummaryLink}
      onEventClick={handleShiftEventClick}
      plantDowntimeHref={getMajorOutageLeadPlantDowntimePagePath(plantId)}
      rcfaListHref={maintainAnalysisLinkPath}
    />
  )
}
